<div>
    <div class="modal-header red">
        <div class="container-fluid">
            <div class="row modal-header-row">
                <div class="modal-icon icon fill-white" aria-label="logo" [inlineSVG]="'assets/ico/budget.svg'">
                </div>
                <span class="modal-title" id="modal-basic-title">Error while bulk edit</span>
                <div class="modal-icon icon fill-white close-icon" (click)="close()" aria-label="close"
                    [inlineSVG]="'assets/ico/close-24px.svg'"></div>
            </div>
        </div>
    </div>
    <div class="modal-body">
        <div class="fullwidth">
            <div class="container-fluid">
                <div class="row mt-2 mb-2" style="padding: 0px 15px 0px 15px;">
                    <div>While bulk edit Budgets, <strong>{{successes.length}}</strong> updated successfully and <strong>{{errors.length}}</strong> had errors while updating.<br /><br /></div>
                    <div style="display: block; width: 100%;margin-bottom: 10px;font-weight: 800;">Errors:</div>
                    <div *ngFor="let error of errors,let i = index, let last = last;" style="display: block; width: 100%;">
                        <p [class.pb-2]="errors.length > 1 && !last">
                            <span *ngIf="error.message" class="error-details"><strong>{{i + 1}}.
                                    {{error.message}}</strong></span>
                            <span *ngIf="error.details" class="error-secondary-details">{{error.details}}</span>
                            <span *ngIf="!error.message && !error.details"
                                class="error-details"><strong>{{'modals.error.unknownError' |
                                    translate}}</strong></span>
                            <span *ngIf="error.errorTraceId"
                                class="error-secondary-details"><strong>{{'modals.error.traceID' | translate}}:
                                </strong>{{error.errorTraceId}}</span>
                        </p>
                    </div>
                </div>

            </div>
        </div>
    </div>
    <div class="modal-footer p-0">
        <div class="container-fluid m-0 p-0">
            <span class="btn modal-btn save" (click)="close()">{{'buttons.close' | translate }}</span>
        </div>
    </div>
</div>